import {
  Container,
  LeftColumn,
  Title,
  Description,
  ActionContainer,
  ColumnRight,
} from './match-daily-limit.styled';

const MatchLimitDailyBase = ({
  Background,
  Icon,
  title,
  description,
  FilledButton,
  GhostButton,
  InsightsElement,
}: MatchDailyLimitProps):JSX.Element => {
  return (
    <Container>
      { !!Background && Background }
      <LeftColumn>
        { Icon }
        <Title>
          { title }
        </Title>
        <Description>
          { description }
        </Description>
        <ActionContainer>
          { FilledButton }
          { !!GhostButton && GhostButton }
        </ActionContainer>
      </LeftColumn>
      <ColumnRight>
        { InsightsElement }
      </ColumnRight>
    </Container>
  );
};

export default MatchLimitDailyBase;
